import React, { useLayoutEffect, useRef, useState } from 'react';
import {
  getDrawingDimFontPx,
  measureLiveDimensionOverlays,
} from '../lib/drawingDimensionOverlays';

const VmkQuoteDrawing = ({ svgHtml, width, height, compact = false, skipDimensionOverlays = false }) => {
  const wrapRef = useRef(null);
  const [overlays, setOverlays] = useState([]);
  const fontPx = getDrawingDimFontPx(compact);

  useLayoutEffect(() => {
    const wrap = wrapRef.current;
    if (skipDimensionOverlays || !wrap || !svgHtml || !width || !height) {
      setOverlays([]);
      return undefined;
    }

    const updateOverlays = () => {
      const svg = wrap.querySelector('svg');
      if (!svg) {
        setOverlays([]);
        return;
      }

      setOverlays(measureLiveDimensionOverlays(wrap, svg, width, height));
    };

    updateOverlays();
    requestAnimationFrame(updateOverlays);

    const observer = new ResizeObserver(() => {
      requestAnimationFrame(updateOverlays);
    });
    observer.observe(wrap);
    const svg = wrap.querySelector('svg');
    if (svg) observer.observe(svg);

    return () => observer.disconnect();
  }, [svgHtml, width, height, skipDimensionOverlays]);

  return (
    <div ref={wrapRef} className="vmk-drawing-wrap relative w-full">
      <div
        className="vmk-drawing-inner w-full flex justify-center items-start"
        dangerouslySetInnerHTML={{ __html: svgHtml }}
      />
      {overlays.length > 0 && (
        <div className="vmk-dim-labels" aria-hidden="true">
          {overlays.map((overlay) => (
            <span
              key={overlay.id}
              className={`vmk-dim-label-overlay${overlay.align === 'start' ? ' vmk-dim-label-overlay--height' : ''}`}
              style={{
                left: `${overlay.left}px`,
                top: `${overlay.top}px`,
                fontSize: `${fontPx}px`,
              }}
            >
              {overlay.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default VmkQuoteDrawing;
